import { useIntl } from "react-intl";

const ServiceStatusPages = () => {
    const intl = useIntl();

    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.ServiceStatusPages.header",
            defaultMessage: "Service status pages"
        }),
        body: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.ServiceStatusPages.body",
            defaultMessage:
                "Opsgenie provides service-level status pages for stakeholders to view information about the status of incidents and progress of resolution."
        })
    };
    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.body}</p>
        </>
    );
};

export default ServiceStatusPages;
